import React from "react"
import { StaticImage } from "gatsby-plugin-image"

const ImageMO11 = () => {

  return (
    <StaticImage
      src="../../images/JPG-FEMALE-LOOK001-1.jpg"
      title="Reserved avatar"
      alt="Reserved avatar"
    />
  )
}

export default ImageMO11
